import { ifAuthenticated } from '@/router/before'

export const devPages = [
  {
    path: '/test-roles',
    name: 'ChangeRoleView',
    meta: {
      icon: ['fas', 'sync'],
      isDisplayInSidebar: true,
      group: 'Dev',
      displayName: 'Смена ролей и прав',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ChangeRoleRoute" */ '@/views/auth/ChangeRoleRoute.vue'
      ),
  },
  {
    path: '/test-user',
    name: 'ChangeUserView',
    meta: {
      icon: ['fa', 'user-circle'],
      isDisplayInSidebar: true,
      group: 'Dev',
      displayName: 'Смена пользователя',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ChangeUserRoute" */ '@/views/auth/ChangeUserRoute.vue'
      ),
  },
]
